import React from 'react'
import logo from "./../Utils/imgs/logo512.png";
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { removeUser } from '../../../App/Utils/userSlice';
import { ERROR_SCREEN_CONSTANTS } from '../../constants';

const ErrorScreen = ({ error = null }) => {
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(removeUser());
  }

  return (
    <div className='w-full h-screen flex flex-col items-center justify-center gap-5'>
      <div className='bg-secondaryBlue rounded-full border border-black/30 p-6'>
        <img src={logo} alt="RIWA Logo" className='w-20 h-20 object-cover'/>
      </div>
      {
        error === null ? (
          <>
            <h1 className='sm:text-[100px] text-5xl text-primary font-bold'>{ERROR_SCREEN_CONSTANTS.FOUR_0_FOUR}</h1>
            <p className='text-lg max-w-[min(400px,90%)] text-center'>{ERROR_SCREEN_CONSTANTS.NOT_FOUND_ERROR}</p>
            <Link to="/" className='px-12 py-3 rounded-full text-white bg-primary hover:bg-primary/75 duration-150 ease-linear font-semibold'>{ERROR_SCREEN_CONSTANTS.ERROR_HOME}</Link>
          </>
        ) : (
          <>
            {/* <h1 className='sm:text-[100px] text-5xl text-primary font-bold'>404</h1> */}
            <p className='text-lg max-w-[min(400px,90%)] text-center'>{ERROR_SCREEN_CONSTANTS.LOGIN_AGAIN_ERROR}</p>
            <Link onClick={handleLogout} to="/login" className='px-12 py-3 rounded-full text-white bg-primary hover:bg-primary/75 duration-150 ease-linear font-semibold'>{ERROR_SCREEN_CONSTANTS.ERROR_LOGIN}</Link>
          </>
        )
      }
    </div>
  )
}

export default ErrorScreen